// extracted by css-extract-rspack-plugin
export default {"Box":"table-group-separator-module__Box__gf9mwI2"};